
























import Vue from 'vue';

import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from '@/components/cards/GenericCard.vue';

import Attachments from './Attachments.vue';

export default Vue.extend({
  components: {
    GenericCard,
    Attachments,
  },
  props: {
    documentableType: {
      type: String,
      required: true,
    },
    documentableId: {
      type: String,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    closeLink: {
      type: String,
      required: true,
    },
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Medium });
    this.$parent.$on('close', this.redirect);
  },
  methods: {
    redirect() {
      document.location.href = this.closeLink;
    },
  },
});
